import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DoubleCounter from 'components/shared/counters/double/DoubleCounter';
import Emoji from 'components/shared/Emoji';
import routes from 'common/routes';

function SessionStatusCounters() {
  const { t } = useTranslation(['sessions']);
  const navigate = useNavigate();

  const sessionsCreatedThisMonthCounter = useSelector(
    (state) => state.session.counters.createdThisMonth
  );
  const sessionsFinishedThisMonthCounter = useSelector(
    (state) => state.session.counters.finishedThisMonth
  );

  return (
    <DoubleCounter
      emoji={<Emoji label={t('sessionStatus', { ns: 'sessions' })} symbol="📅" />}
      title={t('monthlySessionStatus', { ns: 'sessions' })}
      onClick={() => navigate(routes.listSession.path)}
      counters={[
        {
          title: t('scheduled', { ns: 'sessions' }),
          counter: sessionsCreatedThisMonthCounter
        },
        {
          title: t('finished', { ns: 'sessions' }),
          counter: sessionsFinishedThisMonthCounter
        }
      ]}
    />
  );
}

export default SessionStatusCounters;
